export default {
    //General Listing Etc
    list: 'report/list',
    autocomplete: 'report/autocomplete',
    addConnection: 'report/addConnection',
    listConnections: 'report/listConnections',
    detail: 'report/detail',
    scheduleList: 'report/scheduleList',
    runNow: 'report/runNow',

    //FTP
    ftpList: 'report/ftpList',
    ftpById: 'report/ftpById',
    ftpEdit: 'report/ftpEdit',
    ftpAdd: 'report/ftpAdd',
    
    //Add/Edit
    add: 'report/add',
    edit: 'report/edit',

    //History
    withHistory: 'report/withHistory',
    history: 'report/history',
    recentHistory: 'report/recentHistory',

    download: 'report/download',

    //View Report
    retrieveCache: 'report/retrieveCache',
    lastQueued: 'report/lastQueued',

    removeUser: 'report/removeUser',
    addUser: 'report/addUser',

    removeEmail: 'report/removeEmail',
    addEmail: 'report/addEmail',
    updateEmails: 'report/updateEmails',

    changeSchedule: 'report/changeSchedule'
}
